module.exports = __webpack_public_path__ + "img/floating_badge_avatar@2x.e6cfed0e.png";